import * as z from "zod/v4";

const exportBillCsvInput_ = z.object({ billId: z.string() });
export const exportBillCsvInput: z.ZodType<ExportBillCsvInput> =
  exportBillCsvInput_;
export interface ExportBillCsvInput
  extends z.infer<typeof exportBillCsvInput_> {}

const exportBillCsvOutput_ = z.object({ url: z.string() });
export const exportBillCsvOutput: z.ZodType<ExportBillCsvOutput> =
  exportBillCsvOutput_;
export interface ExportBillCsvOutput
  extends z.infer<typeof exportBillCsvOutput_> {}

export const exportBillCsv = {
  name: "exportBillCsv" as const,
  input: exportBillCsvInput,
  output: exportBillCsvOutput,
};
